<div class="full-height layout-column recommendation-groups-list-container">
  <div class="groups-by py-3 px-2">
    <span class="selected" translate>Group By Store</span>
  </div>
  <div class="scroller-headers layout-row layout-align-start-center">
    <span class="flex" translate>Recommendation for</span>
    <span class="star-blue-span flex layout-row layout-align-start-center gap-2">
      <bringoz-icon fill="blue" iconName="star-blue"></bringoz-icon>
      <div class="panel-title">{{ 'Recommendations' | translate }}</div>
    </span>
    <span class="flex-5"></span>
  </div>
  <div class="flex layout-column">
    <div class="full-height flex layout-column">
      <cdk-virtual-scroll-viewport [itemSize]="40" class="flex viewport" (scroll)="getNextBatch()">
        <app-recommendation-groups-list-item *cdkVirtualFor="let recommendationGroup of recommendationGroups"
                                       [recommendationGroup]="recommendationGroup"
                                       appBringozIdGenerator="recommendation_viewed"
                                       (click)="onSelectGroupClick(recommendationGroup)"
                                       class="item">
        </app-recommendation-groups-list-item>
      </cdk-virtual-scroll-viewport>
    </div>
  </div>
</div>

